export enum StripeProductPriceEnum {
  SERVICE_FEE_ID = 'service-fee',
  ONE_TIME_FEE_ID = 'one_time',
  SINGLE_HYDROTEST_PRODUCT_ID = 'original-hydro-price-per-test',

}
